export default {
  GET_INVESTOR_GOAL_DETAIL_QUERY: Symbol.for('GET_INVESTOR_GOAL_DETAIL_QUERY'),
  INVESTOR_GOAL_DETAIL_REPOSITORY: Symbol.for('INVESTOR_GOAL_DETAIL_REPOSITORY'),
};
